/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { Grid, Link, makeStyles, Typography } from '@material-ui/core';

import IconDcm from '../../assets/images/ic-dcm.svg';
import IconDoc from '../../assets/images/ic-doc.svg';
import { ReactComponent as IconDownload } from '../../assets/images/ic-download.svg';
import IconLoadingBlue from '../../assets/images/ic-loading-blue.svg';
import IconPicture from '../../assets/images/ic-picture.svg';
import IconPlaySubstract from '../../assets/images/ic-play-substract.svg';
import { ReactComponent as IconShare } from '../../assets/images/ic-share.svg';
import { ReactComponent as IconTrash } from '../../assets/images/ic-trash.svg';
import IconVideo from '../../assets/images/ic-video.svg';
import { caseStatuses } from '../../models/Case';
import { DCM, DOCS, VIDEO, IMAGE, DOCX } from '../../models/Resource';
import { downloadFile } from '../../utils/files.js';
import LoadingButton from '../common/LoadingButton';

const useStyles = makeStyles((theme) => {
  return {
    additionalContainerEmpty: {
      alignItems: 'center',
      backgroundColor: '#F5F5F5',
      borderRadius: '5px',
      display: 'flex',
      justifyContent: 'center',
      marginTop: '8px',
      minHeight: '90px',
      padding: '16px',
    },
    additionalEmptyText: {
      textAlign: 'center',
    },
    additionalFileContainer: {
      alignItems: 'center',
      backgroundColor: '#F5F5F5',
      borderRadius: '4px',
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '8px',
      padding: '8px 12px',
    },
    additionalFileName: {
      color: '#172B4D',
      fontSize: '12px',
      lineHeight: '16px',
      maxWidth: '150px',
      wordBreak: 'break-all',
    },
    additionalFileTitleContainer: {
      alignItems: 'center',
      display: 'flex',
    },
    additionalFilesContainer: {
      marginTop: '28px',
    },
    additionalIconImage: {
      height: '100%',
      marginRight: '12px',
      width: '20px',
    },
    additionalIconInteraction: {
      height: '16px',
      marginRight: '8px',
      width: '16px',
    },
    additionalIconInteractionDownload: {
      fill: theme.palette.primary.main,
      stroke: theme.palette.primary.main,
    },
    additionalIconUpload: {
      transform: 'rotate(180deg)',
    },
    additionalInteractionText: {
      color: theme.palette.primary.main,
      fontSize: '12px',
      lineHeight: '16px',
      marginBottom: '0px',
    },
    additionalNoFilesFound: {
      marginBottom: '8px',
    },
    additionalSubtitle: {
      color: '#999999',
      fontSize: '12px',
      lineHeight: '16px',
      marginTop: '8px',
    },
    additionalTitle: {
      color: '#172B4D',
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '21px',
      marginBottom: '0px',
      marginRight: '4px',
    },
    additionalViewMore: {
      color: theme.palette.primary.main,
      cursor: 'pointer',
      display: 'inline-block',
      fontSize: '12px',
      lineHeight: '18px',
      marginTop: '12px',
      padding: '0px',
    },
    buttonInteractionText: {
      color: theme.palette.primary.main,
      fontSize: '14px',
      lineHeight: '18px',
      marginBottom: '0px',
    },
    buttonInteractionTextDisabled: {
      color: '#999999',
      fontSize: '14px',
      lineHeight: '18px',
      marginBottom: '0px',
    },
    buttonViewVideo: {
      padding: '11px 16px',
    },
    buttonViewVideoIcon: {
      height: '18px',
      marginRight: '10px',
      width: '18px',
    },
    disabledImages: {
      color: '#999999 !important',
      cursor: 'not-allowed !important',
    },
    hasImages: {
      color: theme.palette.primary.main,
    },
    iconInteraction: {
      height: '16px',
      marginRight: '5px',
      width: '16px',
    },
    iconInteractionDownload: {
      fill: theme.palette.primary.main,
      stroke: theme.palette.primary.main,
    },
    iconInteractionShare: {
      stroke: theme.palette.primary.main,
    },
    iconInteractionTrash: {
      stroke: theme.palette.primary.main,
    },
    iconLoading: {
      height: '44px',
      width: '44px',
    },
    imagesSubtitle: {
      color: '#666666',
      fontSize: '12px',
      lineHeight: '18px',
      textAlign: 'center',
    },
    imagesSubtitleContainer: {
      border: '1px solid #CCCCCC',
      borderRadius: '4px',
      marginBottom: 'px',
      marginTop: '12px',
      padding: '8px',
    },
    noImages: {
      color: '#B12A2A',
    },
    selectedRecordDataContainer: {
      background: '#F5F5F5',
      borderRadius: '5px',
      padding: '10px',
    },
    selectedRecordDataContent: {
      color: '#172B4D',
      fontSize: '12px',
      lineHeight: '18px',
      marginBottom: '0px',
      wordBreak: 'break-all',
    },
    selectedRecordDataContentLink: {
      cursor: 'pointer',
      fontSize: '13px',
      lineHeight: '18px',
      marginBottom: '0px',
    },
    selectedRecordDataTitle: {
      color: '#999999',
      fontSize: '12px',
      fontWeight: '500',
      lineHeight: '15px',
      marginBottom: '2px',
    },
    typographyNoVideoReport: {
      color: '#999999',
      fontSize: '12px',
      lineHeight: '20px',
      textAlign: 'center',
    },
    typographySelected: {
      color: '#999999',
      fontSize: '14px',
      lineHeight: '20px',
      marginBottom: '8px',
    },
    typographyTitle: {
      color: '#172B4D',
      fontSize: '26px',
      fontWeight: '500',
      lineHeight: '30px',
      marginBottom: '12px',
    },
    upgradeNote: {
      color: '#999999',
      fontSize: '11px',
      fontWeight: 'normal',
      lineHeight: '30px',
    },
    uploadActions: {
      color: '#8C8C8C',
      display: 'flex',
      fontSize: '12px',
      fontWeight: '400',
      marginTop: '1rem',
      width: 'fit-content',
    },
    videoReportContainer: {
      marginTop: '32px',
    },
    videoReportLoading: {
      color: '#999999',
      fontSize: '12px',
      lineHeight: '20px',
      marginBottom: '10px',
      textAlign: 'center',
    },
    videoReportSubtitle: {
      color: '#999999',
      fontSize: '12px',
      lineHeight: '20px',
      marginBottom: '20px',
    },
    videoReportTitle: {
      color: '#172B4D',
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '21px',
      marginBottom: '8px',
    },
  };
});

const allowedStatusesAdditionalFiles = [
  caseStatuses.delayed.value,
  caseStatuses['in-progress'].value,
  caseStatuses['in-review'].value,
  caseStatuses.incomplete.value,
  caseStatuses.new.value,
  caseStatuses['pending-upload'].value,
  caseStatuses['pending-images'].value,
  caseStatuses.review.value,
  caseStatuses['upload-shared'].value,
];

const iconSetup = {
  [DCM]: IconDcm,
  [DOCS]: IconDoc,
  [IMAGE]: IconPicture,
  [VIDEO]: IconVideo,
};

export default ({
  onDownload,
  onRemove,
  onViewReport,
  studyStatus,
  onRequestReport,
  onViewImages,
  isLoading$,
  onShareImage,
  centerRemoveIcon,
  onOpenAdditionalFileDialog,
  onViewMoreAdditionalFiles,
  onMakePayment,
  onViewAdditionalFile,
}) => {
  const reportCases = useMemo(
    () => ({
      completed: {
        btnAction: onViewReport,
        btnText: 'View Video Report',
        btnVisible: true,
        note: 'Your video report is ready to be viewed.',
      },
      'in-progress': {
        btnText: '',
        btnVisible: false,
        note: 'Your video report is being created and will be ready by your requested delivery date.',
      },
      'not-paid': {
        btnAction: onMakePayment,
        btnText: 'Make Payment',
        btnVisible: true,
        disableIcon: true,
        note: 'Report request received, please make payment to complete your order.',
      },
      notAvailable: {
        btnAction: onRequestReport,
        btnText: 'Request Report',
        btnVisible: true,
        note: 'You have not requested a video report for this study.',
      },
    }),
    [onViewReport, onMakePayment, onRequestReport]
  );

  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!isLoading$) return null;
    const subscription = isLoading$.subscribe(setIsLoading);
    return () => subscription.unsubscribe();
  }, [isLoading$]);

  const handleUploadAdditionalFile = useCallback(() => {
    if (onOpenAdditionalFileDialog) onOpenAdditionalFileDialog();
  }, [onOpenAdditionalFileDialog]);

  const handleClickViewMore = useCallback(
    (files) => {
      if (onViewMoreAdditionalFiles) onViewMoreAdditionalFiles(files);
    },
    [onViewMoreAdditionalFiles]
  );

  const handleClickViewFile = useCallback(
    (file) => {
      if (onViewAdditionalFile) onViewAdditionalFile(file);
    },
    [onViewAdditionalFile]
  );

  const renderChangeFilesButton = useCallback(() => {
    const { viewerLink } = studyStatus;

    if (!viewerLink && studyStatus.case) {
      return (
        <Grid container style={{ marginTop: '8px' }} justify="flex-start">
          <Typography className={classes.buttonInteractionTextDisabled}>No MRI or CT Scan images available</Typography>
        </Grid>
      );
    }

    const removeIcon = !['in-progress', 'not-paid'].includes(studyStatus.status) && (
      <>
        {/* Divider, only shows when remove icon is not centered  */}
        {!centerRemoveIcon && (
          <Grid item>
            <div style={{ borderLeft: '1px solid #E0E0E0', height: '20px', margin: '0px 8px 0px 0px', width: '0px' }} />
          </Grid>
        )}

        {/* The remove icon */}
        <Grid item>
          <div onClick={onRemove} style={{ alignItems: 'center', cursor: 'pointer', display: 'flex' }}>
            <IconTrash className={`${classes.iconInteraction} ${classes.iconInteractionTrash}`} />
            <Typography className={classes.buttonInteractionText}>Remove</Typography>
          </div>
        </Grid>
      </>
    );

    return (
      <>
        <Grid container style={{ marginTop: '15px' }} justify="flex-start">
          <Grid item>
            <div onClick={onShareImage} style={{ alignItems: 'center', cursor: 'pointer', display: 'flex' }}>
              <IconShare className={`${classes.iconInteraction} ${classes.iconInteractionShare}`} />
              <Typography className={classes.buttonInteractionText}>Share Files</Typography>
            </div>
          </Grid>
          <Grid item>
            <div style={{ borderLeft: '1px solid #E0E0E0', height: '20px', margin: '0px 8px', width: '0px' }} />
          </Grid>

          <Grid item>
            <div onClick={onDownload} style={{ alignItems: 'center', cursor: 'pointer', display: 'flex', marginRight: '8px' }}>
              <IconDownload className={`${classes.iconInteraction} ${classes.iconInteractionDownload}`} />
              <Typography className={classes.buttonInteractionText}>Download</Typography>
            </div>
          </Grid>

          {/* Remove Icon */}
          {!centerRemoveIcon && removeIcon}
        </Grid>

        {/* Centered remove Icon */}
        {studyStatus.status !== 'in-progress' && centerRemoveIcon && (
          <Grid container style={{ marginTop: '4px', width: '200px' }} justify="center">
            {removeIcon}
          </Grid>
        )}
      </>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onDownload, onRemove, onShareImage, studyStatus]);

  const renderReport = useCallback(() => {
    const sectionStatus = reportCases[studyStatus.status] || reportCases.notAvailable;
    return (
      <>
        <Typography className={classes.videoReportSubtitle}>{sectionStatus.note}</Typography>
        <LoadingButton disabled={!sectionStatus.btnVisible} className={classes.buttonViewVideo} onClick={sectionStatus.btnAction} variant="contained" color="primary" fullWidth>
          {!sectionStatus?.disableIcon && <img src={IconPlaySubstract} className={classes.buttonViewVideoIcon} alt="icon" />}
          {sectionStatus.btnText || 'View Video Report'}
        </LoadingButton>
      </>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportCases, studyStatus]);

  const renderAdditionalFiles = useCallback(() => {
    if (!studyStatus?.case?.id) return null;

    const additionalFiles = studyStatus?.case?.additionalFiles || [];
    const isAllowedToUpload = studyStatus.case?.id && allowedStatusesAdditionalFiles.includes(studyStatus.case?.status?.value);
    const renderedFiles = additionalFiles.length > 3 ? additionalFiles.slice(0, 3) : [...additionalFiles];

    if (!isAllowedToUpload && !additionalFiles?.length) return null;

    let mainContent = '';
    if (!additionalFiles?.length) {
      const emptyText = 'No additional files found';

      mainContent = (
        <div className={classes.additionalContainerEmpty}>
          <div>
            <Typography className={[classes.additionalSubtitle, classes.additionalNoFilesFound, classes.additionalEmptyText].join(' ')}>{emptyText}</Typography>

            {isAllowedToUpload && (
              <div onClick={handleUploadAdditionalFile} style={{ alignItems: 'center', cursor: 'pointer', display: 'flex', justifyContent: 'center', marginRight: '8px' }}>
                <IconDownload className={`${classes.additionalIconInteraction} ${classes.additionalIconInteractionDownload} ${classes.additionalIconUpload}`} />
                <Typography className={classes.additionalInteractionText}>Upload</Typography>
              </div>
            )}
          </div>
        </div>
      );
    } else {
      const mappedFiles = renderedFiles.map((file) => {
        const { fileName = '', type, description, uuid } = file;
        const fileTitle = fileName || description || '';

        const cleanFileName = fileTitle.startsWith('0-') ? fileTitle.slice(2, fileTitle.length) : fileTitle;
        const selectedIcon = iconSetup[type] || IconDoc;
        const isDocxFile = file.originalType === DOCX;

        return (
          <div key={uuid} className={classes.additionalFileContainer}>
            {/* Icon Title */}
            <div className={classes.additionalFileTitleContainer}>
              <img src={selectedIcon} className={classes.additionalIconImage} alt="" />
              <Typography className={classes.additionalFileName}>{cleanFileName}</Typography>
            </div>

            {/* Button */}
            {!isDocxFile ? (
              <div onClick={() => handleClickViewFile(file)} style={{ alignItems: 'center', cursor: 'pointer', display: 'flex', justifyContent: 'center', marginRight: '8px' }}>
                <Typography className={classes.additionalInteractionText}>View</Typography>
              </div>
            ) : (
              <a
                title="Download File"
                onClick={() => downloadFile(file)}
                style={{ alignItems: 'center', cursor: 'pointer', display: 'flex', justifyContent: 'center', marginRight: '8px', textDecoration: 'none' }}>
                <IconDownload className={`${classes.additionalIconInteraction} ${classes.additionalIconInteractionDownload}`} />
              </a>
            )}
          </div>
        );
      });

      mainContent = (
        <>
          {mappedFiles}

          {additionalFiles?.length > 3 && (
            <Typography onClick={() => handleClickViewMore(additionalFiles)} className={classes.additionalViewMore}>
              View More
            </Typography>
          )}
        </>
      );
    }

    const showTitleUploadButton = (additionalFiles?.length && isAllowedToUpload) || null;

    return (
      <div className={classes.additionalFilesContainer}>
        <Grid container alignItems="center" justify="space-between">
          <Typography className={classes.additionalTitle}>Additional Files</Typography>

          {showTitleUploadButton && (
            <div onClick={handleUploadAdditionalFile} style={{ alignItems: 'center', cursor: 'pointer', display: 'flex', justifyContent: 'center', marginRight: '8px' }}>
              <IconDownload className={`${classes.additionalIconInteraction} ${classes.additionalIconInteractionDownload} ${classes.additionalIconUpload}`} />
              <Typography className={classes.additionalInteractionText}>Upload</Typography>
            </div>
          )}
        </Grid>
        <Typography className={classes.additionalSubtitle}>Additional radiology scans and reports</Typography>

        {mainContent}
      </div>
    );
  }, [classes, handleClickViewMore, handleClickViewFile, handleUploadAdditionalFile, studyStatus]);

  const hasImage = useMemo(() => {
    if (studyStatus?.imageCount > 0) return true;
    return studyStatus?.case?.dicomStudy?.type !== 'dcm';
  }, [studyStatus?.imageCount, studyStatus?.case?.dicomStudy?.type]);

  if (isLoading) {
    return (
      <div style={{ padding: '140px 0px 110px' }}>
        <Typography className={classes.videoReportLoading}>Loading Details...</Typography>
        <Grid container justify="center">
          <Grid item>
            <img src={IconLoadingBlue} className={`${classes.iconLoading} rotate`} alt="Mediphany loading" />
          </Grid>
        </Grid>
      </div>
    );
  }

  if (!studyStatus) {
    return (
      <div style={{ padding: '140px 0px 110px' }}>
        <Typography className={classes.typographyNoVideoReport}>
          No video report
          <br />
          information to show.
        </Typography>
      </div>
    );
  }

  const { case: caseData } = studyStatus;

  return (
    <div>
      <Typography className={classes.typographySelected}>Selected</Typography>
      <Typography className={classes.typographyTitle}>{studyStatus.title || caseData?.uploadSharedInfo?.studyName || caseData?.caseLinkInfo?.studyDescription || 'N/A'}</Typography>

      {/* Title, Images */}
      {studyStatus.viewerLink && (
        <Grid container>
          <Grid item xs={6} style={{ paddingRight: '5px' }}>
            <div className={classes.selectedRecordDataContainer}>
              <Typography className={classes.selectedRecordDataTitle}>Title</Typography>
              <Typography className={classes.selectedRecordDataContent}>{studyStatus.title || 'N/A'}</Typography>
            </div>
          </Grid>
          <Grid item xs={6} style={{ paddingLeft: '5px' }}>
            <div className={classes.selectedRecordDataContainer}>
              <Typography className={classes.selectedRecordDataTitle}>Files</Typography>
              <Link onClick={onViewImages} disabled={!studyStatus.isAbleToViewRecord || !studyStatus.viewerLink} style={{ display: 'block' }} component="button">
                <Typography
                  className={`${classes.selectedRecordDataContentLink} ${hasImage ? classes.hasImages : classes.noImages} ${studyStatus.viewerLink ? '' : classes.disabledImages}`}>
                  View Files
                </Typography>
              </Link>
            </div>
          </Grid>
        </Grid>
      )}

      {/* Share, Download, Remove */}
      {renderChangeFilesButton()}

      {studyStatus.viewerLink && (
        <div className={classes.imagesSubtitleContainer}>
          <Typography className={classes.imagesSubtitle}>Files refer to your MRI or CT Scan images</Typography>
        </div>
      )}

      {/* Additional Files */}
      {renderAdditionalFiles()}

      {/* Video Report */}
      <div className={classes.videoReportContainer}>
        <Typography className={classes.videoReportTitle}>Video Report</Typography>
        {renderReport()}
      </div>
    </div>
  );
};
